module.exports = __webpack_public_path__ + "static/media/ferret.2f3aba89.svg";